import { render, staticRenderFns } from "./CompleteEmailRecovery.vue?vue&type=template&id=8fc8b79a&"
import script from "./CompleteEmailRecovery.vue?vue&type=script&lang=js&"
export * from "./CompleteEmailRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports